import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { GraduationCap } from 'lucide-react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Marca o desmarca un vuelo como «de instrucción» (motivo ≥10 caracteres, auditado)
export function TrainingFlightControl({ flightId, training, canEdit, onChanged }) {
    const [open, setOpen] = useState(false);
    const [reason, setReason] = useState('');
    const [busy, setBusy] = useState(false);
    const enabled = !!training?.enabled;
    const save = async () => {
        setBusy(true);
        try {
            const r = await axios.patch(`${API}/flights/${flightId}/training`, { enabled: !enabled, reason: reason.trim() });
            toast.success(r.data.training_flight.enabled ? 'Vuelo marcado como de instrucción' : 'Marca de instrucción retirada');
            setOpen(false); setReason('');
            onChanged?.(r.data.training_flight);
        } catch (e) { toast.error(e.response?.data?.detail || 'No se pudo guardar'); }
        finally { setBusy(false); }
    };
    return (
        <div className="rounded-md border border-border/40 p-2 space-y-2" data-testid="training-flight-control">
            <div className="flex items-center gap-2 text-xs">
                <GraduationCap className={`w-4 h-4 ${enabled ? 'text-sky-600 dark:text-sky-400' : 'text-muted-foreground'}`} />
                <span data-testid="training-flight-status">{enabled ? `Vuelo de instrucción · ${training.reason}` : 'Vuelo normal (posiciones según ficha)'}</span>
                {canEdit && !open && <Button size="sm" variant="outline" className="h-7 ml-auto" onClick={() => setOpen(true)} data-testid="training-flight-toggle">{enabled ? 'Quitar marca' : 'Marcar de instrucción'}</Button>}
            </div>
            {open && (
                <div className="space-y-2">
                    <Textarea rows={2} value={reason} onChange={e => setReason(e.target.value)} placeholder="Motivo (mínimo 10 caracteres)" className="text-xs" data-testid="training-flight-reason" />
                    <div className="flex justify-end gap-2">
                        <Button size="sm" variant="ghost" className="h-7" onClick={() => setOpen(false)}>Cancelar</Button>
                        <Button size="sm" className="h-7" disabled={busy || reason.trim().length < 10} onClick={save} data-testid="training-flight-save">Guardar</Button>
                    </div>
                </div>
            )}
        </div>
    );
}
